import { Box, styled, Switch } from "@mui/material";

export const StyledToggleIconable = styled(Switch)`
  width: 3.143rem;
  height: auto;
  padding: 0;

  .MuiSwitch-track {
    background-color: ${({ theme }) => theme.wsc.palette.neutral[600]};
    height: ${({ theme }) => theme.wsc.size.l};
    width: 3.143rem;
    border-radius: ${(props) => props.theme.wsc.radius.l};
    opacity: 1;
  }

  .MuiSwitch-switchBase {
    background-color: ${({ theme }) => theme.wsc.palette.neutral[100]};
    color: ${({ theme }) => theme.wsc.palette.neutral[600]};
    padding: 0;
    height: 1.429rem;
    width: 1.429rem;
    top: 0.143rem;
    left: 0.143rem;

    > .material-symbols-outlined {
      display: inline-flex;
    }

    &.Mui-checked {
      background-color: ${({ theme }) => theme.wsc.palette.neutral[600]};
      color: ${({ theme }) => theme.wsc.palette.primary[300]};

      & + .MuiSwitch-track {
        background-color: ${({ theme }) => theme.wsc.palette.primary[300]};
        opacity: 1;
      }
    }

    &.Mui-disabled {
      background-color: ${({ theme }) => theme.wsc.palette.neutral[400]};
      color: ${({ theme }) => theme.wsc.palette.neutral[300]};

      & + .MuiSwitch-track {
        opacity: 1;
        background-color: ${({ theme }) => theme.wsc.palette.neutral[500]};
      }
    }

    &.Mui-checked.Mui-disabled {
      background-color: ${({ theme }) => theme.wsc.palette.neutral[400]};
      color: ${({ theme }) => theme.wsc.palette.primary[700]};

      & + .MuiSwitch-track {
        background-color: ${({ theme }) => theme.wsc.palette.primary[700]};
      }
    }
  }

  :hover {
    .MuiSwitch-switchBase:not(.Mui-disabled) {
      background-color: ${({ theme }) => theme.wsc.palette.neutral[100]};
    }

    .MuiSwitch-track {
      background-color: ${(props) => props.theme.wsc.palette.neutral[500]};
    }

    .MuiSwitch-switchBase.Mui-checked:not(.Mui-disabled) {
      color: ${({ theme }) => theme.wsc.palette.primary[100]};
      background-color: ${({ theme }) => theme.wsc.palette.neutral[600]};
    }

    .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track {
      background-color: ${({ theme }) => theme.wsc.palette.primary[100]};
    }

    .Mui-disabled + .MuiSwitch-track {
      background-color: ${({ theme }) => theme.wsc.palette.neutral[500]};
    }

    .Mui-disabled.Mui-checked + .MuiSwitch-track {
      background-color: ${({ theme }) => theme.wsc.palette.primary[700]};
    }
  }
`;

export const StyledWrapper = styled(Box)`
  position: relative;
  display: inline-flex;

  :has(.Mui-disabled) > .toggle-secondary-icon {
    color: ${({ theme }) => theme.wsc.palette.neutral[400]};
  }
`;

export const StyledSecondaryIcon = styled("span", {
  shouldForwardProp: (prop) => prop !== "isChecked",
})<{
  isChecked: boolean;
}>`
  pointer-events: none;
  display: inline-flex;
  color: ${(props) =>
    props.theme.wsc.palette.neutral[props.isChecked ? 600 : 100]};
  position: absolute;
  ${(props) =>
    props.isChecked
      ? `
    left: 0.429rem;
  `
      : `
    right: 0.429rem;
  `}
  top: 0;
  transform: translateY(50%);

  > .material-symbols-outlined {
    display: inline-flex;
  }
`;
